var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isAddEditUserOpened)?_c('add-edit-user'):_vm._e(),(_vm.isAddEditTeamOpened)?_c('add-edit-team'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }